import { Button, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { getResource } from "../../common/localization";
import { renderClose, useSimpleDialog, yesNoButtons } from "../../common/dialog";
import { UseEntityStore } from "../../common/entityStore";
import { TmOrderDto } from "./common";
import { useTmCallResults } from "../../common/enum";
import { propEnumField } from "../../common/entityStoreForm";

function getText(key: string, defaultMessage?: string) {
    return getResource("Ui.TmCallResult." + key, defaultMessage) as string;
}

enum TmCallResult {
    Ordered = "1",
    PhoneInvalid = "3c",
    NotLivingThere = "4a",
    Dead = "4b",
    BlackList = "4d",
    WantsToBeForgotten = "4f",
    OrdersHimself = "5a",
    NoPet = "7z",
}

const specialCallResults = [
    TmCallResult.PhoneInvalid,
    TmCallResult.NotLivingThere,
    TmCallResult.Dead,
    TmCallResult.BlackList,
    TmCallResult.WantsToBeForgotten,
    TmCallResult.OrdersHimself,
    TmCallResult.NoPet,
];

export function TmCallResultDialog(props: {
    close: () => void;
    useStore: UseEntityStore<TmOrderDto>;
    resolve(save: boolean): void;
}) {
    const isTmCallResultSet = props.useStore(p => p.clientData.tmCallResultId != null);
    const simpleDialog = useSimpleDialog();
    function ask(title: string, message: string) {
        return new Promise<boolean>(resolve => simpleDialog.show(title, message, undefined, yesNoButtons(() => resolve(true), () => resolve(false))));
    }
    function askForWhatPhoneIsInvalid() {
        return new Promise<"mob" | "tel" | "both" | "cancel">(resolve => simpleDialog.show(getText("WhatPhoneIsInvalid.Title"), getText("WhatPhoneIsInvalid.Content"), undefined, (close: () => void): JSX.Element => <>
            <Button onClick={() => { resolve("mob"); close(); }}>{getText("WhatPhoneIsInvalid.Mob")}</Button>
            <Button onClick={() => { resolve("tel"); close(); }}>{getText("WhatPhoneIsInvalid.Tel")}</Button>
            <Button onClick={() => { resolve("both"); close(); }}>{getText("WhatPhoneIsInvalid.Both")}</Button>
            <Button onClick={() => { resolve("cancel"); close(); }}>{getResource("Ui.Cancel")}</Button>
        </>, true));
    }
    return <>
        {simpleDialog.render()}
        {renderClose(props.close)}
        <DialogTitle>{getText("Title")}</DialogTitle>
        <DialogContent>
            <Grid container spacing={2}>
                <Grid item xs={12}>{propEnumField(props.useStore)("tmCallResultId", getText("Result"), useTmCallResults, {
                    filter: p => {
                        const e = props.useStore.getState().clientData;
                        return (p.code !== TmCallResult.PhoneInvalid || (e.tel.trim() !== "" || e.mob.trim() !== "")) &&
                            p.code !== TmCallResult.Ordered;
                    }
                })}</Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button color="positive" disabled={!isTmCallResultSet} onClick={async () => {
                const tmCallResultId = props.useStore.getState().clientData.tmCallResultId;
                const tmCallResult = useTmCallResults.getState().items.find(p => p.id === tmCallResultId)!;
                if (specialCallResults.includes(tmCallResult.code as TmCallResult) &&
                    !await ask(getText("Confirm.Title"), getText("Confirm.Content").replaceAll("{0}", tmCallResult.name))) {
                    return;
                }
                props.useStore.getState().setClientDataProp("isMobInvalid", false);
                props.useStore.getState().setClientDataProp("isTelInvalid", false);
                if (tmCallResult.code === TmCallResult.PhoneInvalid) {
                    if (props.useStore.getState().clientData.mob.trim() !== "" &&
                        props.useStore.getState().clientData.tel.trim() !== "") {
                        const what = await askForWhatPhoneIsInvalid();
                        if (what === "mob") {
                            props.useStore.getState().setClientDataProp("isMobInvalid", true);
                        } else if (what === "tel") {
                            props.useStore.getState().setClientDataProp("isTelInvalid", true);
                        } else if (what === "both") {
                            props.useStore.getState().setClientDataProp("isMobInvalid", true);
                            props.useStore.getState().setClientDataProp("isTelInvalid", true);
                        } else {
                            return;
                        }
                    } else if (props.useStore.getState().clientData.mob.trim() !== "") {
                        props.useStore.getState().setClientDataProp("isMobInvalid", true);
                    } else if (props.useStore.getState().clientData.tel.trim() !== "") {
                        props.useStore.getState().setClientDataProp("isTelInvalid", true);
                    }
                }
                props.resolve(true);
                props.close();
            }}>{getResource("Ui.Save")}</Button>
            <Button onClick={() => props.close()}>{getResource("Ui.Cancel")}</Button>
        </DialogActions>
    </>;
}
